import { useCallback, useEffect, useState } from 'react';

import { Range } from '@app/shared/components';

import type { ContentType } from '@pages/Clients/NewClientsList/components/MultiFilter/types';

import { useNewClientsListContext } from '@pages/Clients/NewClientsList/context/useNewClientsListContext';
import { PF } from '@pages/Clients/NewClientsList/data/constants';
import { FilterWrapper } from '@pages/Clients/NewClientsList/ui';

export const RecordsCountFilter: ContentType = ({ open, onClose, id }) => {
  const { filtersMap, onChangeRecordsCountRange } = useNewClientsListContext();
  const { recordsCountRange } = filtersMap.get(id)!;

  const [localRange, setLocalRange] = useState<{
    from: number | null;
    to: number | null;
  }>({
    from: null,
    to: null,
  });

  const onConfirm = useCallback(() => {
    onChangeRecordsCountRange(localRange, id);
    onClose?.();
  }, [id, localRange, onChangeRecordsCountRange, onClose]);

  useEffect(() => {
    setLocalRange(open ? recordsCountRange : { from: null, to: null });
  }, [open, recordsCountRange]);

  return (
    <FilterWrapper onConfirm={onConfirm}>
      <Range
        values={localRange}
        onChange={(range) =>
          setLocalRange({ from: range.from ?? null, to: range.to ?? null })
        }
        fromTitle="от"
        toTitle="до"
        inputsClassName={`${PF}__range-inputs`}
        min={0}
        max={Number.MAX_SAFE_INTEGER}
      />
    </FilterWrapper>
  );
};
